export default function formatCurrency(cents) {
  if (typeof cents !== 'number') {
    return cents;
  }

  return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'EUR' });
}
